import React, { Fragment } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';

import CommonDataService from '../../services/CommonDataService';
import SearchForm, { TextSearchHeader } from '../searchForm';
import CheckboxList from '../form/CheckboxList';

const UserSeachHeader = () => (
  <TextSearchHeader placeholder={"Search by first and/or last name"} />
);

class UserFilter extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      filterValues: {
        searchText: "",
        availability: [],
        locations: [],
        roles: []
      },
      availabilityTypes: [],
      officeLocations: [],
      projectRoles: []
    }
  }

  componentDidMount() {

    CommonDataService.getProjectRoles().then(result => {
      this.setState({ projectRoles: result });
    });

    CommonDataService.getLocations().then(result => {
      this.setState({ officeLocations: result });
    });

    CommonDataService.getAvailabilityTypes().then(result => {
      this.setState({ availabilityTypes: result });
    });
  }

  render() {
    return (
      <SearchForm
        initialValues={this.state.filterValues}
        searchHeader={UserSeachHeader}
        onSubmit={this.props.onSearch}
        onReset={this.props.onClear}>
        <Fragment>
          <div className="box">
            <cite>Availability</cite>
            <CheckboxList
              name="availability"
              options={this.state.availabilityTypes} />
          </div>
          <div className="box">
            <cite>Location</cite>
            <CheckboxList
              name="locations"
              options={this.state.officeLocations} />
          </div>
          <div className="box">
            <cite>Role</cite>
            <CheckboxList
              name="roles"
              options={this.state.projectRoles} />
          </div>
        </Fragment>
      </SearchForm>
    );
  }
}

UserFilter.propTypes = {
  onSearch: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired
}

export default UserFilter;



// WEBPACK FOOTER //
// ./src/components/users/UserFilter.js